var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter",
    transform: "translate(-64 -778)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(64 778)",
    fill: "#cee8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Twitter-2",
    "data-name": "Twitter",
    d: "M33.9,19.866a9.91,9.91,0,0,1-2.82.8,4.9,4.9,0,0,0,2.16-2.8A10.216,10.216,0,0,1,30.12,19.1a4.884,4.884,0,0,0-3.6-1.6,4.983,4.983,0,0,0-4.92,5.038,4.713,4.713,0,0,0,.12,1.137,13.745,13.745,0,0,1-10.11-5.253,5.126,5.126,0,0,0,1.5,6.728,4.639,4.639,0,0,1-2.22-.614,5.065,5.065,0,0,0,3.93,5.008,5.277,5.277,0,0,1-2.22.092,4.957,4.957,0,0,0,4.59,3.5A9.75,9.75,0,0,1,9.9,35.227,13.644,13.644,0,0,0,17.46,37.5c9.06,0,13.98-7.68,13.98-14.316a4.646,4.646,0,0,0-.03-.645,9.9,9.9,0,0,0,2.49-2.673Z",
    transform: "translate(66.1 774.5)",
    fill: "#457186"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.9b7727db4c4087cb51242313fb7591d2.svg";
export { ForwardRef as ReactComponent };